import {
  DashboardEditFields,
  type DashboardType,
  type TagMap,
} from "@/components/DashboardEditFields";
import type { PropertyDef } from "@/hooks/useProperties";
import { Button } from "@simplicity/ui";

// SIM-1464 — `schoolYears` / `categories` props dropped: <DashboardEditFields>
// derives those option lists from the `properties` array internally.
export type EditFormProps = {
  dashboardId: string;
  dashboardType: DashboardType;
  editTitle: string;
  editUrl: string;
  editSchoolYear: string;
  editCategory: string;
  properties: PropertyDef[];
  tagMap: TagMap;
  onCommitEdit: () => void;
  onCancelEdit: () => void;
  onSetEditTitle: (v: string) => void;
  onSetEditUrl: (v: string) => void;
  onSetEditSchoolYear: (v: string) => void;
  onSetEditCategory: (v: string) => void;
  onSetTagMap: (m: TagMap) => void;
};

export function DashboardEditForm({
  dashboardId,
  dashboardType,
  editTitle,
  editUrl,
  editSchoolYear,
  editCategory,
  properties,
  tagMap,
  onCommitEdit,
  onCancelEdit,
  onSetEditTitle,
  onSetEditUrl,
  onSetEditSchoolYear,
  onSetEditCategory,
  onSetTagMap,
}: EditFormProps) {
  const keyHandler = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") onCommitEdit();
    if (e.key === "Escape") onCancelEdit();
  };
  return (
    <div className="space-y-2">
      <DashboardEditFields
        dashboardId={dashboardId}
        dashboardType={dashboardType}
        editTitle={editTitle}
        setEditTitle={onSetEditTitle}
        editUrl={editUrl}
        setEditUrl={onSetEditUrl}
        editSchoolYear={editSchoolYear}
        setEditSchoolYear={onSetEditSchoolYear}
        editCategory={editCategory}
        setEditCategory={onSetEditCategory}
        properties={properties}
        tagMap={tagMap}
        setTagMap={onSetTagMap}
        variant="inline"
        onKeyDown={keyHandler}
        // eslint-disable-next-line jsx-a11y/no-autofocus -- inline edit triggered by user click; user-initiated focus is WCAG 3.2.1-compliant
        autoFocus
      />
      <div className="flex gap-2">
        <Button size="sm" onClick={onCommitEdit}>
          Save
        </Button>
        <Button variant="outline" size="sm" onClick={onCancelEdit}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
